import {Component, OnInit} from '@angular/core';

import {OutBreadcrumb} from '../../shared/tree-diagram/breadcrumbs/breadcrumbs.interfaces';

import {RegulationTreeService} from './regulation-tree.service';

@Component({
  selector: 'gp-regulation-tree',
  templateUrl: './regulation-tree.component.html',
  styleUrls: ['./regulation-tree.component.css']
})

export class RegulationTreeComponent implements OnInit {

  public tree: any = {};
  public diagramHeight: string;
  public selectedLeaf;

  constructor(private regulationTreeService: RegulationTreeService) {

  }

  public ngOnInit(): void {
    this.regulationTreeService.getNodes()
      .pipe(
      )
      .subscribe((response) => {
        this.tree.children = response.data;
        this.fetchTree();
      });
  }

  public fetchTree(): void {
    this.tree.children.forEach((child) => {
      child.parent = child.attributes.parentreg;
      child.photoHref = child.attributes.flagImage;
      child.name = child.attributes.nickName;
      child.subtitles = [{
        id: 0,
        name: child.attributes.nickName
      }, {}, {}];
      child.isPhotoBase64 = true;
      child.isDisabled = !child.attributes.write;
    });
    this.tree.isDotsVisible = false;
  }

  public selectTreeLeaf(breadcrumb: OutBreadcrumb): void {
    this.selectedLeaf = this.tree.children.find((child) => child.id === breadcrumb.id);
  }

  public updateDiagramHeight(height: number): void {
    this.diagramHeight = `calc(100vh - ${height + 58}px)`;
  }
}
